import { configMap, pitchTypeMap, pitchMap, tableHeaderMap, pitchTypeTagMap, chartMap } from "./Map"
import { sortByTag } from "../Utils/Sort"
import { useState } from "react"

export const LeaderboardTable = ({ type, data, id }) => {
  const [sortTarget, setSortTarget] = useState('Player')
  const [reverse, setReverse] = useState(false)

  const handleHeaderOnClick = (e) => {
    if (e.target.id === sortTarget) {
      setReverse(!reverse)
    } else {
      setSortTarget(e.target.id)
      setReverse(false)
    }
  }

  const displayEntries = (type) => {
    let res = []
    for (const e in configMap[type]) {
      res.push(<th id={e} onClick={handleHeaderOnClick} >{configMap[type][e]}<br /><span>{e}</span></th>)
    }
    return res
  }

  const displayData = (type, data) => {
    let res = []
    for (const p of data) {
      let row = [<td>{data.indexOf(p) + 1}</td>]
      for (const e in configMap[type]) {
        if (e === 'Rk') continue
        row.push(<td>{p[e]}</td>)
      }
      res.push(<tr>{row}</tr>)
    }
    return res
  }
  return (
    <table className="score_person_form tab_table" id={id}>
      <tbody>
        <tr>
          {displayEntries(type)}
        </tr>
        {displayData(type, sortByTag(data, sortTarget, reverse))}
      </tbody>
    </table>
  )
}

export const MovementDisplay = ({ data, pitchType, setPitchType }) => {
  const displayOption = () => {
    let options = []
    for (const p in pitchTypeMap) {
      options.push(<option value={p}>{`${pitchTypeMap[p]} ${p}`}</option>)
    }
    return options
  }

  const displayMovement = (data, pitchType) => {
    if (pitchType === 'Pitch') {
      return data.map((e) => (
        <div className={`ball ${pitchMap[e.type]}`} style={e.position}>
          <div className="ball_dialog">
            選手: {e.name}<br />
            均速: {e.velocity}<br />
            轉速: {e.spin}<br />
            球種: {configMap['pitcher'][e.type]}<br />
            水平位移: {e.hbreak}<br />
            垂直位移: {e.vbreak}<br />
          </div>
        </div>
      ))
    } else {
      let pitches = data.filter((e) => (e.type === pitchType))
      return pitches.map((e) => (
        <div className={`ball ${pitchMap[e.type]}`} style={e.position}>
          <div className="ball_dialog">
            選手: {e.name}<br />
            均速: {e.velocity}<br />
            轉速: {e.spin}<br />
            球種: {configMap['pitcher'][e.type]}<br />
            水平位移: {e.hbreak}<br />
            垂直位移: {e.vbreak}<br />
          </div>
        </div>
      ))
    }
  }

  return (
    <div className="chart tab_table">
      <div className="topic">{`${pitchTypeMap[pitchType]}位移`}</div>
      <div className="topic_e">{`${pitchType} Movement`}</div>
      <div className="chart_select">
        <select onChange={(e) => { setPitchType(e.target.value) }}>
          <option selected disabled value='Pitch'>請選擇球種</option>
          {displayOption()}
        </select>
      </div>
      <div className={`chart_movement mv_${pitchType}`}>
        {displayMovement(data, pitchType)}
      </div>
    </div>
  )
}

export const Table = ({ tableName, data, withLeftTitle = false, withSubTitle = false }) => {
  const displayHeader = (tname) => {
    let headers = []
    if (withLeftTitle) {
      for (const k in tableHeaderMap[tname]) {
        headers.push(<th>{tableHeaderMap[tname][k]}<br /><span>{k}</span></th>)
      }
    } else {
      for (const k of tableHeaderMap[tname]) {
        headers.push(<th>{k}</th>)
      }
    }
    return (
      <tr>
        {headers}
      </tr>
    )
  }
  const displayData = (data) => {
    return data.map((e) => {
      return (
        <tr>
          {withLeftTitle? <td className="left_title">{pitchTypeMap[pitchTypeTagMap[e[0]]]} <span>{e[0]}</span></td>:<td>{e[0]}</td>}
          {e.slice(1).map((i)=>(<td>{i}</td>))}
        </tr>
      )
    })
  }
  return (
    <table className="score_person_form">
      <tbody>
        {displayHeader(tableName)}
        {displayData(data)}
      </tbody>
    </table>
  )
}

export const SubTableFrame = ({ title, tables }) => {
  return (
    <>
      <div className="page_tab_frame2">
        <div className="tab_block tab_selected">
          <div className="tab">{title}</div>
        </div>
      </div>
      <div className="tab_content">
        {tables}
      </div>
    </>
  )
}

export const PersonalPitcherTable = ({ data }) => {
  let byPitchTable = [<Table tableName='pitcherByPitchType' data={data.pitchTypes} withLeftTitle={true} withSubTitle={true} />]
  let overallTable = [
    <Table tableName='overallOne' data={[data.overall[0]]} />, <Table tableName='overallTwo' data={[data.overall[1]]} />
  ]
  return (
    <>
      <SubTableFrame title='總覽' tables={byPitchTable} />
      <SubTableFrame title='總覽' tables={overallTable} />
    </>
  )
}
